import axiosInstance from '../axios/axiosInstance';
import { Grade } from '../model/response';

export const findAllGrade = async () => {
  const { data } = await axiosInstance.get<Grade[]>('grades', { params: { fromCMS: true } });
  return data;
};

export const toggleGradeWebviewActive = async (id: string) => {
  await axiosInstance.patch(`grades/${id}/toggle-web-view-active`);
};
